export const TIME_12H = "h:mma";
export const M_DD_YYYY = "M/dd/yyyy";
export const MMM_D_YYYY = "MMM d, yyyy";
export const FULL_DATE_TIME = "MM/dd/yyyy '@' h:mmaaa z";
export const SERVER_FORMAT = "yyyy-MM-dd";
